<template>
  <div class="mobile-top-up-result">
    <!-- 交易成功 -->
    <div v-if="topUpDetailData.status && topUpDetailData.status.code === UTILITIES_ORDER_STATUS.success" class="status-icon success_icon">
      <md-icon name="success" size="lg" />
      <p class="success">{{ $t('completed') }}</p>
    </div>
    <!-- 交易失败 -->
    <div v-if="topUpDetailData.status && topUpDetailData.status.code === UTILITIES_ORDER_STATUS.fail" class="status-icon fail">
      <md-icon name="warn" size="lg" />
      <p>{{ $t('transaction_failed') }}</p>
      <p v-if="topUpDetailData.fiRetMessage" style="text-align: center; width: 230px;">({{ topUpDetailData.fiRetMessage }})</p>
    </div>
    <!-- 处理中 -->
    <div v-if="topUpDetailData.status && topUpDetailData.status.code === UTILITIES_ORDER_STATUS.processing" class="status-icon wait">
      <md-icon name="time" size="lg" />
      <p>{{ $t('processing') }}</p>
    </div>
    <div class="result-list-info">
      <md-field>
        <md-detail-item
          :title="$t('service_name')"
          :content="topUpDetailData.serviceName"
        />
        <md-detail-item
          :title="$t('mobileNumber')"
          :content="topUpDetailData.businessNo"
        />
        <md-detail-item
          :title="$t('amount')"
          :content="topUpDetailData.paymentAmount | fenToYanAndFormat"
        />
        <md-detail-item
          :title="$t('transaction_fee')"
          :content="topUpDetailData.fee | fenToYanAndFormat"
        />
        <md-detail-item
          :title="$t('totalAmount')"
          :content="`${topUpDetailData.paymentAmount + topUpDetailData.fee }` | fenToYanAndFormat"
        />
        <md-detail-item
          :title="$t('transaction_time')"
          :content="topUpDetailData.tradeTime"
        />
        <md-detail-item
          :title="$t('transaction_no')"
          :content="topUpDetailData.tradeNo"
        />
      </md-field>
    </div>
    <div class="remarks-info">
      <Block :title="$t('remarks')">
        <p>{{ $t('remarks1') }}</p>
        <p>{{ $t('remarks2') }}</p>
        <p>{{ $t('remarks3') }}</p>
      </Block>
    </div>
    <div class="result-done-btn">
      <md-button type="primary" @click="done">{{ $t('done') }}</md-button>
    </div>
  </div>
</template>

<script>
import { InputItem, Field, RadioGroup, RadioBox, Button, DetailItem, Icon } from 'mand-mobile'
import { fenToYanAndFormat } from '@/utils/format-amount'
import Block from '@/components/Block'
import { topUpDetail } from '@/api/mobile-top-up'
import { UTILITIES_ORDER_STATUS } from '@/constants'
// 手机充值结果
export default {
  name: 'MobileTopUpResult',

  components: {
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [RadioBox.name]: RadioBox,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [DetailItem.name]: DetailItem,
    [Icon.name]: Icon,
    Block

  },

  filters: {
    fenToYanAndFormat
  },

  data () {
    return {
      UTILITIES_ORDER_STATUS,
      topUpDetailData: {}
    }
  },
  created () {
    this.getTopUpDetail()
  },
  methods: {
    // 获取充值详情
    getTopUpDetail () {
      topUpDetail({ utilitiesNo: this.$route.query.utilitiesNo }).then((data) => {
        this.topUpDetailData = data
      })
    },
    // 完成返回首页
    done () {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style scoped lang="scss">

.result-list-info {
  margin-top: 110px;
}

::v-deep .remarks-info {
  margin-top: 40px;

  .flash-block-title {
    font-size: 28px;
    color: #333;
    font-weight: 500;
    padding-left: 36px;
  }

  .flash-block_body {
    padding: 48px 36px;
    color: #595959;
    line-height: 48px;
    font-size: 28px;
  }
}

.mobile-top-up-result {
  width: 100%;
  height: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  ::v-deep .transfer_info {
    display: block;
  }

  .status-icon {
    margin-top: 108px;
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      font-size: 32px;
      font-weight: 500;
      margin-top: 26px;
      color: #65c32c;
    }

    .reason {
      font-size: 24px;
      color: #7f7f7f;
    }

    .md-icon.icon-font {
      font-size: 124px;
      color: #65c32c;
    }
  }

  .fail {
    .md-icon.icon-font,
    p {
      color: #fa5151;
    }
  }

  .wait {
    .md-icon.icon-font,
    p {
      color: #ffc300;
    }
  }
}

.result-done-btn {
  width: 100%;
  padding: 52px 0 104px;
}
</style>
